const baseURL = window.location.protocol + '//' + window.location.host;

export const MainCtrl = ['$scope', 'User', 'config', ($scope, User, config) => {
    $scope.host = window.location.protocol + "//" + window.location.hostname;
    $scope.config = config;
    $scope.statusMap = {
        inProgress: 1,
        submitted: 4,
        archived: 5
    };
    $scope.signingStatusMap = {
        signed: 1,
        canSign: 2,
        cannotSign: 3
    };
    $scope.status = {
        unsaved: false,
        definition_title: '',
        definition_title_checked: false,
        definition_title_available: false,
    };
    User.get((data) => {
        if (data.status === 'ok') {
            if (data.user.notifications.length === 0) {
                data.user.notifications = {};
            }
            $scope.user = data.user;
            $scope.now = data.now;
        } else {
            $scope.errors = [data.error];
        }
    });
    $scope.userHasRole = role => {
        if ($scope.user) {
            const result = $scope.user.roles.filter(r => {
                return r._id === role._id;
            });
            return result.length > 0;
        }
        return false;
    };
    $scope.isImageFilename = (filename) => {
        if (filename !== undefined && filename.length) {
            const ext = filename.split(".").pop();
            const extensions = ['jpg','jpeg','gif','png'];
            if (extensions.indexOf(ext) > -1) {
                return true;
            }
        }
        return false;
    };
}];

export const DashboardCtrl = ['$scope', 'Definitions', 'Favourites', ($scope, Definitions, Favourites) => {
    $scope.loaded = {
        definitions: false,
        favourites: false
    };
    Definitions.get((data) => {
        if (data.status === 'ok') {
            $scope.loaded.definitions = true;
            $scope.definitions = data.definitions;
        } else {
            $scope.errors = [data.error];
        }
    });
    Favourites.get((data) => {
        if (data.status === 'ok') {
            $scope.loaded.favourites = true;
            $scope.favourites = data.definitions;
        } else {
            $scope.errors = [data.error];
        }
    });
}];

export const UnfinishedChecklistsController = ['$scope', 'ChecklistSearch', 'Definitions', ($scope, ChecklistSearch, Definitions) => {
    $scope.loaded = false;
    $scope.pagination = {
        totalItems: 0,
        itemsPerPage: 20,
        currentPage: 1
    };
    $scope.checklists = [];
    $scope.orderBy = "updated";
    $scope.orderReverse = true;
    $scope.getPage = (pageNumber) => {
        const params = {
            type: 'unfinished',
            mode: 'complete',
            page: pageNumber,
            itemsPerPage: $scope.pagination.itemsPerPage,
            search: $scope.search,
            orderBy: $scope.orderBy,
            orderReverse: $scope.orderReverse,
            filters: JSON.stringify($scope.filters)
        };
        ChecklistSearch.get(params, (data) => {
            if (data.status === 'ok') {
                $scope.loaded = true;
                $scope.pagination.totalItems = data.total;
                $scope.pagination.currentPage = pageNumber;
                $scope.checklists = data.checklists;
            } else {
                $scope.$parent.errors = [data.error];
            }
        });
    };
    $scope.$watchGroup(['orderBy','orderReverse'], () => {
        $scope.getPage(1);
    });

    Definitions.get(data => {
        if (data.status === 'ok') {
            $scope.definitions = data.definitions;
        } else {
            $scope.errors = [data.error];
        }
    });
    $scope.search = "";
    $scope.filtersToggle = false;
    $scope.filters = {
        excludeDefinitions: []
    };
    $scope._filters = {
        definitions: {}
    };
    $scope.$watch('filters', () => {
        $scope.loaded = false;
        $scope.getPage(1);
    }, true);
    $scope.$watch('_filters', () => {
        $scope.filters.excludeDefinitions = _.keys(_.pickBy($scope._filters.definitions, (val, key) => {
            return !val;
        }));
    }, true);
    $scope.$watch('definitions', () => {
        if ($scope.definitions) {
            $scope._filters.definitions = _.keyBy($scope.definitions, o => {
                return o._id;
            });
            $scope._filters.definitions = _.mapValues($scope._filters.definitions, () => {
                return true;
            });
        }
    });
}];

export const TeamsChecklistsController = ['$scope', 'ChecklistSearch', ($scope, ChecklistSearch) => {
    $scope.loaded = false;
    $scope.pagination = {
        totalItems: 0,
        itemsPerPage: 20,
        currentPage: 1
    };
    $scope.checklists = [];
    $scope.search = "";
    $scope.getPage = pageNumber => {
        const params = {
            type: 'team',
            mode: 'complete',
            page: pageNumber,
            itemsPerPage: $scope.pagination.itemsPerPage,
            search: $scope.search
        };
        ChecklistSearch.get(params, data => {
            if (data.status === 'ok') {
                $scope.loaded = true;
                $scope.pagination.totalItems = data.total;
                $scope.pagination.currentPage = pageNumber;
                $scope.checklists = data.checklists;
            } else {
                $scope.$parent.errors = [data.error];
            }
        });
    };
    $scope.getPage(1);
}];

export const ArchivedChecklistsController = ['$scope', 'ChecklistSearch', ($scope, ChecklistSearch) => {
    $scope.loaded = false;
    $scope.pagination = {
        totalItems: 0,
        itemsPerPage: 20,
        currentPage: 1
    };
    $scope.checklists = [];
    $scope.search = "";
    $scope.getPage = pageNumber => {
        const params = {
            type: 'archived',
            mode: 'complete',
            page: pageNumber,
            itemsPerPage: $scope.pagination.itemsPerPage,
            search: $scope.search
        };
        ChecklistSearch.get(params, data => {
            if (data.status === 'ok') {
                $scope.loaded = true;
                $scope.pagination.totalItems = data.total;
                $scope.pagination.currentPage = pageNumber;
                $scope.checklists = data.checklists;
            } else {
                $scope.$parent.errors = [data.error];
            }
        });
    };
    $scope.getPage(1);
}];

export const AllSubmittedChecklistsController = ['$scope', 'ChecklistSearch', ($scope, ChecklistSearch) => {
    $scope.loaded = false;
    $scope.pagination = {
        totalItems: 0,
        itemsPerPage: 20,
        currentPage: 1
    };
    $scope.checklists = [];
    $scope.search = "";
    $scope.getPage = pageNumber => {
        const params = {
            type: 'submitted',
            mode: 'complete',
            page: pageNumber,
            itemsPerPage: $scope.pagination.itemsPerPage,
            search: $scope.search,
            all: true
        };
        ChecklistSearch.get(params, data => {
            if (data.status === 'ok') {
                $scope.loaded = true;
                $scope.pagination.totalItems = data.total;
                $scope.pagination.currentPage = pageNumber;
                $scope.checklists = data.checklists;
            } else {
                $scope.$parent.errors = [data.error];
            }
        });
    };
    $scope.getPage(1);
}];

export const AllArchivedChecklistsController = ['$scope', 'ChecklistSearch', ($scope, ChecklistSearch) => {
    $scope.loaded = false;
    $scope.pagination = {
        totalItems: 0,
        itemsPerPage: 20,
        currentPage: 1
    };
    $scope.checklists = [];
    $scope.search = "";
    $scope.getPage = pageNumber => {
        const params = {
            type: 'archived',
            mode: 'complete',
            page: pageNumber,
            itemsPerPage: $scope.pagination.itemsPerPage,
            search: $scope.search,
            all: true
        };
        ChecklistSearch.get(params, data => {
            if (data.status === 'ok') {
                $scope.loaded = true;
                $scope.pagination.totalItems = data.total;
                $scope.pagination.currentPage = pageNumber;
                $scope.checklists = data.checklists;
            } else {
                $scope.$parent.errors = [data.error];
            }
        });
    };
    $scope.getPage(1);
}];

export const AllUnsubmittedChecklistsController = ['$scope', 'ChecklistSearch', ($scope, ChecklistSearch) => {
    $scope.loaded = false;
    $scope.pagination = {
        totalItems: 0,
        itemsPerPage: 20,
        currentPage: 1
    };
    $scope.checklists = [];
    $scope.search = window.location.getQueryParameter('search');
    $scope.getPage = pageNumber => {
        const params = {
            type: 'unsubmitted',
            mode: 'complete',
            page: pageNumber,
            itemsPerPage: $scope.pagination.itemsPerPage,
            search: $scope.search,
            all: true
        };
        ChecklistSearch.get(params, data => {
            if (data.status === 'ok') {
                $scope.loaded = true;
                $scope.pagination.totalItems = data.total;
                $scope.pagination.currentPage = pageNumber;
                $scope.checklists = data.checklists;
            } else {
                $scope.$parent.errors = [data.error];
            }
        });
    };
    $scope.getPage(1);
}];

export const DeleteChecklistController = ['$scope', 'Checklist', ($scope, Checklist) => {
    $scope.url = '';
    $scope.checklist = null;
    $scope.$watch('url', url => {
        const id = url.split("/").clean('').pop();
        if (id && id.length) {
            if (id.length === 8) {
                Checklist.get({id:id}, data => {
                    if (data.status === 'ok') {
                        $scope.checklist = data.checklist;
                    } else {
                        $scope.checklist = null;
                    }
                });
            } else {
                $scope.checklist = null;
            }
        }
    }, true);
}];

export const UserChecklistsController = ['$scope', 'ChecklistSearch', ($scope, ChecklistSearch) => {
    const userId = window.location.pathname.split("/").clean('').pop();
    $scope.loaded = false;
    $scope.pagination = {
        totalItems: 0,
        itemsPerPage: 20,
        currentPage: 1
    };
    $scope.checklists = [];
    $scope.search = "";
    $scope.getPage = pageNumber => {
        const params = {
            type: 'user',
            mode: 'complete',
            user: userId,
            page: pageNumber,
            itemsPerPage: $scope.pagination.itemsPerPage,
            search: $scope.search
        };
        ChecklistSearch.get(params, data => {
            if (data.status === 'ok') {
                $scope.loaded = true;
                $scope.pagination.totalItems = data.total;
                $scope.pagination.currentPage = pageNumber;
                $scope.checklists = data.checklists;
            } else {
                $scope.$parent.errors = [data.error];
            }
        });
    };
    $scope.getPage(1);
}];

export const DefinitionsCtrl = ['$scope', 'Definitions', ($scope, Definitions) => {
    $scope.loaded = {
        definitions: false
    };
    $scope.organisation = $('#org_id').text();
    Definitions.get({all: true, orderBy: 'updated', orderReverse: true, organisation: $scope.organisation}, data => {
        if (data.status === 'ok') {
            $scope.loaded.definitions = true;
            $scope.definitions = data.definitions;
        } else {
            $scope.errors = [data.error];
        }
    });
    $scope.search = {
        definitions: ""
    };
    $scope.rolesToString = roles => {
        let r = roles.map(role => {
            return role.title;
        });
        return r.join(", ");
    }
}];

export const DefinitionCtrl = ['$scope', ($scope) => {
    $scope.unsavedWarningMode = 'assisted';

    function roleUsedAsSignee(id) {
        let used = false;
        $scope.definition.items.forEach(obj => {
            if (obj.signeeRole && obj.signeeRole._id && obj.signeeRole._id === id) {
                used = true;
            }
        });
        if ($scope.bulkAdd.role && $scope.bulkAdd.role._id && $scope.bulkAdd.role._id === id) {
            used = true;
        }
        return used;
    }

    $scope.getDefaultNewItemRole = () => {
        let defaultRole = {};
        if ($scope.selectedRoles.length > 1) {
            defaultRole = {
                _id: ""
            };
        } else {
            $scope.roles.forEach(role => {
                if (role._id === $scope.selectedRoles[0]) {
                    defaultRole = role;
                }
            });
        }
        return defaultRole;
    };

    $scope.headersSortableOptions = {
        'ui-floating': true,
        'handle': '.drag-and-drop-handle'
    };

    $scope.itemsSortableOptions = {
        'ui-floating': true,
        'handle': '.drag-and-drop-handle',
        'update': function(e, ui) {
            const temp = $scope.toggles.items[ui.item.sortable.dropindex];
            $scope.toggles.items[ui.item.sortable.dropindex] = $scope.toggles.items[ui.item.sortable.index];
            $scope.toggles.items[ui.item.sortable.index] = temp;
        }
    };

    $scope.removeHeaderField = $index => {
        $scope.definition.headers.splice($index, 1);
    };

    $scope.removeItem = $index => {
        $scope.definition.items.splice($index, 1);
        $scope.toggles.items.splice($index, 1);
    };

    $scope.addItemInline = $index => {
        $scope.definition.items.splice($index + 1, 0, {
            signeeRole: $scope.getDefaultNewItemRole()
        });
        $scope.toggles.items.splice($index + 1, 0, true);
    };

    $scope.$watch('definition', (newVal, oldVal) => {
        if (oldVal) {
            $scope.$parent.status.unsaved = true
            if (!newVal.tagsAllowed && oldVal.tagsAllowed) {
                $scope.definition.tagsEditable = false
            }
            if (newVal.tagsEditable && !oldVal.tagsEditable) {
                $scope.definition.tagsAllowed = true
            }
            if (!newVal.imageAllowed && oldVal.imageAllowed) {
                $scope.definition.imageRequired = false;
                $scope.definition.imageEditable = false;
            }
            if (newVal.imageRequired && !oldVal.imageRequired) {
                $scope.definition.imageAllowed = true;
            }
            if (newVal.imageEditable && !oldVal.imageEditable) {
                $scope.definition.imageAllowed = true;
            }
        }
    }, true);

    $scope.$watch('definition.headers', (newVal, oldVal) => {
        if (oldVal) {
            angular.forEach(newVal, (value, key) => {
                $scope.toggles.headers_notes[key] = (value.hasOwnProperty('note') && value.note.length > 0);
                $scope.toggles.headers_defaults[key] = (value.hasOwnProperty('default') && value.default.length > 0);
            });
        }
    }, true);

    $scope.$watch('definition.items', (newVal, oldVal) => {
        if (oldVal) {
            angular.forEach(newVal, (value, key) => {
                if (value.commentRequired && oldVal[key] && !oldVal[key].commentRequired) {
                    value.commentAllowed = true;
                    $scope.definition.items[key] = value;
                }
                if (!value.commentAllowed && oldVal[key] && oldVal[key].commentAllowed) {
                    value.commentRequired = false;
                    $scope.definition.items[key] = value;
                }
                $scope.toggles.items_notes[key] = (value.hasOwnProperty('note') && value.note.length > 0);
            });
        }
    }, true);

    $scope.toggles = {
        headers: true,
        items: [],
        items_notes: [],
        headers_notes: [],
        headers_defaults: [],
        bulk_add: false
    };
    $scope.loaded = {
        definition: false,
        roles: false
    };

    $scope.roles = [];
    $scope.selectedRoles = [];
    $scope.bulkAdd = {
        role: {}
    };

    $scope.itemsVisibilityAction = 'expand';

    $scope.$watch('toggles.items', newVal => {
        const expanded = _.compact(newVal).length;
        $scope.itemsVisibilityAction = (expanded > (newVal.length / 2)) ? 'collapse' : 'expand';
    }, true);

    $scope.toggleItemVisibility = (index, visibility) => {
        $scope.toggles.items[index] = visibility;
    };

    $scope.toggleItemsVisibility = () => {
        _.fill($scope.toggles.items, $scope.itemsVisibilityAction !== 'collapse');
    };

    $scope.toggleRoleSelection = ($event, id) => {
        const index = $scope.selectedRoles.indexOf(id);
        if (index > -1) {
            if (roleUsedAsSignee(id)) {
                $event.preventDefault();
                $scope.errors = ["Cannot unselect role which is used as a signee role."];
            } else {
                $scope.selectedRoles.splice(index, 1);
            }
        } else {
            $scope.selectedRoles.push(id);
        }
    };

    $scope.selectedRolesFilter = role => {
        return $scope.selectedRoles.indexOf(role._id) > -1;
    };

    $scope.saveDefinition = (redirect, preview) => {
        $("input[name='redirect']").val(redirect?1:0);
        $("input[name='preview']").val(preview?1:0);
        $scope.errors = [];
        let i = 0
        $scope.definition.items.forEach(item => {
            i = i + 1
            if (!item.isSeparator && (_.isEmpty(item.signeeRole) || _.isEmpty(item.signeeRole._id))) {
                $scope.errors.push("Choose signee role for item at position " + i + ": \"" + item.title + "\"");
            }
        });
        if ($scope.$parent.status.definition_title_available === false) {
            $scope.errors.push("Please fill in a valid title");
        }
        if (_.isEmpty($scope.errors)) {
            $scope.$parent.status.unsaved = false;
            $("form.definitionForm").submit();
        }
    };
}];

export const DefinitionCreateCtrl = ['$scope', 'Roles', 'DefinitionTitleAvailability', ($scope, Roles, DefinitionTitleAvailability) => {
    $scope.$parent.definition = {
        headers: [{}],
        items: [],
        tagsAllowed: false,
        tagsEditable: false,
        imageAllowed: false,
        imageRequired: false,
        imageEditable: false
    };
    $scope.$parent.loaded.definition = true;
    $scope.$parent.$watch('selectedRoles', (newVal, oldVal) => {
        oldVal && ($scope.$parent.status.unsaved = true);
    }, true);
    Roles.get({}, data => {
        if (data.status === 'ok') {
            $scope.$parent.loaded.roles = true;
            $scope.$parent.roles = data.roles;
        } else {
            $scope.errors = [data.error];
        }
    });

    $scope.title = "";
    $scope.$watch('title', (newVal, oldVal) => {
        $scope.$parent.status.definition_title = newVal;
        if (typeof newVal === 'undefined') {
            $scope.$parent.status.definition_title_available = false;
        }
    }, true);
    $scope.checkTitleAvailability = title => {
        if (title.length) {
            const params = {
                id: $scope.definition._id,
                title: title
            };
            DefinitionTitleAvailability.get(params, data => {
                if (data.status === 'ok') {
                    $scope.$parent.status.definition_title_checked = true;
                    $scope.$parent.status.definition_title_available = data.available;
                } else {
                    $scope.errors = [data.error];
                }
            });
        }
    };
}];

export const DefinitionUpdateCtrl = ['$scope', '$window', 'Definition', 'Roles', 'DefinitionTitleAvailability', ($scope, $window, Definition, Roles, DefinitionTitleAvailability) => {
    const definitionId = window.location.pathname.split("/").clean('').pop();
    Definition.get({id:definitionId}, data => {
        if (data.status === 'ok') {
            $scope.$parent.definition = data.definition;
            $scope.checkTitleAvailability(data.definition.title);
            data.definition.items.forEach(item => {
                $scope.$parent.toggles.items.push(false);
            });
            $scope.$parent.loaded.definition = true;
            $scope.$parent.selectedRoles = data.definition.roles.map(obj => {
                return obj._id;
            });
            $scope.$parent.$watch('selectedRoles', (newVal, oldVal) => {
                if (newVal.length !== oldVal.length) {
                    $scope.$parent.status.unsaved = true;
                }
            }, true);
            if ($scope.preview) {
                const url = $scope.$parent.host + "/checklist-preview/" + $scope.definition.uri;
                $window.open(url, '_blank');
            }
            Roles.get({organisation: $scope.$parent.definition.organisation_id}, data => {
                if (data.status === 'ok') {
                    $scope.$parent.loaded.roles = true;
                    $scope.$parent.roles = data.roles;
                } else {
                    $scope.errors = [data.error];
                }
            });
        } else {
            $scope.errors = [data.error];
        }
    });

    $scope.$watch('definition.title', (newVal, oldVal) => {
        $scope.$parent.status.definition_title = newVal;
        if (typeof newVal === 'undefined') {
            $scope.$parent.status.definition_title_available = false;
        }
    }, true);
    $scope.checkTitleAvailability = title => {
        if (title.length) {
            const params = {
                id: $scope.definition._id,
                title: title
            };
            DefinitionTitleAvailability.get(params, data => {
                if (data.status === 'ok') {
                    $scope.$parent.status.definition_title_checked = true;
                    $scope.$parent.status.definition_title_available = data.available;
                } else {
                    $scope.errors = [data.error];
                }
            });
        }
    };
}];

export const WorkflowsCtrl = ['$scope', 'Definitions', ($scope, Definitions) => {
    $scope.loaded = {
        definitions: false
    };
    $scope.organisation = $('#org_id').text();
    Definitions.get({all: true, orderBy: 'title', organisation: $scope.organisation}, data => {
        if (data.status === 'ok') {
            $scope.loaded.definitions = true;
            $scope.definitions = data.definitions;
        } else {
            $scope.errors = [data.error];
        }
    });
    $scope.search = {
        definitions: ""
    };
}];

export const WorkflowCtrl = ['$scope', '$timeout', '$filter', 'Socket', 'Definition', 'ChecklistsInProgress', ($scope, $timeout, $filter, Socket, Definition, ChecklistsInProgress) => {
    const definitionId = window.location.pathname.split("/").clean('').pop();
    $scope.definition = null;
    $scope.checklistsInProgress = {};
    $scope.loaded = {
        definition: false,
        checklistsInProgress: false
    };
    $scope.syncStatus = 'All changes saved to Chklsty';
    $scope.condensedView = false;
    $scope.condensedViewPossible = false;
    $scope.collapsedSections = {};
    $scope.workflowFilterOptions = {
        tags: [],
        users: [],
    };

    $scope.workflowFilters = {
        tag: {
            _id: "any",
            title: "Any"
        },
        user: {
            _id: "all",
            name: "All",
        },
        dateFrom: "",
        dateTo: "",
    };

    $scope.toggleGroup = (itemId, definitionId) => {
        const storageKey = 'collapsedSections_' + definitionId;
        $scope.collapsedSections[itemId] = !$scope.collapsedSections[itemId];
        localStorage.setItem(storageKey, JSON.stringify($scope.collapsedSections));
    };

    $scope.checklistsPerSection = (itemId) => {
        let cnt = 0;
        const filterWorkflow = $filter('filterWorkflow');
        $scope.definition.items.forEach(item => {
            if (item.groupId === itemId && (item._id in $scope.checklistsInProgress)) {
                const filteredList = filterWorkflow($scope.checklistsInProgress[item._id], $scope.workflowFilters);
                cnt += filteredList.length;
            }
        })
        return cnt;
    };

    const initChecklistsInProgress = (checklists, definition) => {
        $scope.checklistsInProgress = _.groupBy(checklists, value => value.state);
        definition.items.forEach(item => {
            if (item._id in $scope.checklistsInProgress === false) {
                $scope.checklistsInProgress[item._id] = [];
            }
        });
        checklists.forEach(c => {
            Socket.emit('checklist_join', { id: c._id });
        });
    };
    const initWorkflowFilterOptions = (checklists) => {
        const filterOptionsTags = [{
            _id: "any",
            title: "Any"
        }];
        const filterOptionsUsers = [{
            _id: "all",
            name: "All",
        }];
        checklists.forEach(c => {
            if (c.user) {
                filterOptionsUsers.push({
                    _id: c.user._id,
                    name: c.user.first_name + " " + c.user.last_name,
                })
            }
            c.tags.forEach(t => {
                filterOptionsTags.push({
                    _id: t._id,
                    title: t.title,
                })
            });
        });
        $scope.workflowFilterOptions.users = _.uniqWith(filterOptionsUsers, _.isEqual);
        $scope.workflowFilterOptions.tags = _.uniqWith(filterOptionsTags, _.isEqual);
        $('#datepicker').datepicker({
            container: '#datepicker',
            format: "dd-M-yyyy",
            endDate: "+1d",
            clearBtn: true,
            autoclose: true,
            todayHighlight: true
        });
    };
    $scope.setFilterDateRange = (val) => {
        const dateOffset = (24*60*60*1000) * val;
        const today = new Date();
        const d = new Date();
        d.setTime(d.getTime() - dateOffset);
        $('#datepicker input[name="start"]').datepicker('update', d);
        $('#datepicker input[name="end"]').datepicker('update', today);
    };
    $scope.clearFilterDate = () => {
        $scope.workflowFilters.dateFrom = "";
        $scope.workflowFilters.dateTo = "";
    };
    $scope.saveComment = function(checklistId, itemId, comment) {
        Socket.emit('checklist_update', {
            checklist: {
                _id: checklistId,
                item: {
                    _id: itemId,
                    comment: comment
                }
            }
        });
    };
    $scope.commentModalProps = {};
    $scope.checklistMoved = function(checklistId, originalState) {
        let targetState = null;
        let originalItem = _.find($scope.definition.items, { '_id': originalState });
        if (originalItem && originalItem.commentRequired) {
            $scope.commentModalProps = {
                checklistId: checklistId,
                itemId: originalItem._id,
                itemTitle: originalItem.title
            };
            $('#comment-modal').modal('show');
        }
        let originalIndex = _.findIndex($scope.checklistsInProgress[originalState], { '_id': checklistId });
        $scope.checklistsInProgress[originalState].splice(originalIndex, 1);
        angular.forEach($scope.checklistsInProgress, function(val, key) {
            val.forEach(v => {
                if (v._id === checklistId) targetState = key;
            })
        });
        $timeout(() => {
            Socket.emit('checklist_state_update', {
                checklist: {
                    _id: checklistId,
                    state: targetState
                }
            });
        });
    };
    Socket.on('checklist_update', (data) => {
        if (data.status === 'ok') {
            const checklistId = data.checklist._id;
            const newState = data.checklist.state;
            let originalState = null;
            let originalIndex = null;
            angular.forEach($scope.checklistsInProgress, function (val, key) {
                val.forEach((v, k) => {
                    if (v._id === checklistId) {
                        originalState = key;
                        originalIndex = k;
                    }
                })
            });
            $scope.checklistsInProgress[newState].push(data.checklist);
            $scope.checklistsInProgress[originalState].splice(originalIndex, 1);
            $scope.syncStatus = "Last edit was on " + data.checklist._id + " by " + data.checklist.updatedBy.first_name + " " + data.checklist.updatedBy.last_name + ' at ' + data.checklist.updated;
            $scope.$applyAsync();
        } else {
            console.log(data.error);
        }
    });
    Socket.on('checklist_state_update_success', (data) => {
        const index = _.findIndex($scope.checklistsInProgress[data.checklist.state], { '_id': data.checklist._id });
        $scope.checklistsInProgress[data.checklist.state][index] = data.checklist;
        $scope.syncStatus = "All changes saved to Chklsty";
    });
    Socket.on('checklist_state_update_error', (data) => {
        $scope.syncStatus = data.message;
    });
    Socket.on('checklist_submit', (data) => {
        angular.forEach($scope.checklistsInProgress, (val, key) => {
            val.forEach((v, k) => {
                if (v._id === data.checklist._id) {
                    $scope.checklistsInProgress[key].splice(k, 1);
                }
            });
        });
    });

    Definition.get({id:definitionId}, data => {
        if (data.status === 'ok') {
            $scope.definition = data.definition;
            const storageKey = 'collapsedSections_' + $scope.definition._id;
            $scope.collapsedSections = JSON.parse(localStorage.getItem(storageKey) || '{}');
            let currentSeparatorId = null;
            angular.forEach($scope.definition.items, function(item) {
                if (item.isSeparator) {
                    currentSeparatorId = item._id;
                    if (typeof $scope.collapsedSections[currentSeparatorId] === 'undefined') {
                        $scope.collapsedSections[currentSeparatorId] = true;
                    }
                } else {
                    item.groupId = currentSeparatorId;
                }
            });
            $scope.loaded.definition = true;
            $scope.condensedViewPossible = data.definition.items.reduce((acc, cur) => {
                return acc || cur.isSeparator;
            }, false);
            ChecklistsInProgress.get({definition: definitionId}, data => {
                if (data.status === 'ok') {
                    initChecklistsInProgress(data.checklists, $scope.definition);
                    initWorkflowFilterOptions(data.checklists);
                    $scope.loaded.checklistsInProgress = true;
                } else {
                    $scope.errors = [data.error];
                }
            });
        } else {
            $scope.errors = [data.error];
        }
    });
}];

export const OrganisationsCtrl = ['$scope', 'Organisations', ($scope, Organisations) => {
    $scope.loaded = {
        organisations: false
    };
    Organisations.get({orderBy: 'name'}, data => {
        if (data.status === 'ok') {
            $scope.loaded.organisations = true;
            $scope.organisations = data.organisations;
        } else {
            $scope.errors = [data.error];
        }
    });
    $scope.search = {
        organisations: ""
    };
    $scope.usersToString = users => {
        const r = users.map(user => {
            return user.first_name + " " + user.last_name + " (" + user.email + ")";
        });
        return r.join("<br />");
    }
}];

export const OrganisationCtrl = ['$scope', ($scope) => {}];

export const OrganisationCreateCtrl = ['$scope', 'SubdomainAvailability', ($scope, SubdomainAvailability) => {
    $('#frm-organisationForm-phone').intlTelInput({
        hiddenInput: "fullphone"
    });
    $scope.subdomain = '';
    $scope.subdomain_checked = false;
    $scope.subdomain_available = false;
    $scope.$watch('subdomain', subdomain => {
        if (subdomain && subdomain.length === 0) {
            $scope.subdomain_checked = false;
        }
    });
    $scope.checkSubdomainAvailability = subdomain => {
        if (subdomain.length) {
            const params = {
                id: null,
                subdomain: subdomain
            };
            SubdomainAvailability.get(params, data => {
                if (data.status === 'ok') {
                    $scope.subdomain_checked = true;
                    $scope.subdomain_available = data.available;
                } else {
                    $scope.errors = [data.error];
                }
            });
        }
    };
}];

export const OrganisationUpdateCtrl = ['$scope', 'SubdomainAvailability', ($scope, SubdomainAvailability) => {
    $('#frm-organisationForm-phone').intlTelInput({
        hiddenInput: "fullphone"
    });
    $scope.subdomain = '';
    $scope.subdomain_checked = false;
    $scope.subdomain_available = false;
    $scope.$watch('subdomain', subdomain => {
        if (typeof subdomain === 'undefined') {
            $scope.subdomain_checked = true;
            $scope.subdomain_available = false;
        } else {
            const params = {
                id: $('#org_id').text(),
                subdomain: subdomain
            };
            SubdomainAvailability.get(params, data => {
                if (data.status === 'ok') {
                    $scope.subdomain_checked = true;
                    $scope.subdomain_available = data.available;
                } else {
                    $scope.errors = [data.error];
                }
            });
        }
    });
}];

export const OrganisationSettingsFormCtrl = ['$scope', 'SubdomainAvailability', ($scope, SubdomainAvailability) => {
    $('#frm-organisationSettingsForm-phone').intlTelInput({
        hiddenInput: "fullphone"
    });
    $scope.phone = '';
    $scope.subdomain = '';
    $scope.subdomain_checked = false;
    $scope.subdomain_available = false;
    $scope.$watch('subdomain', subdomain => {
        if (typeof subdomain === 'undefined') {
            $scope.subdomain_checked = true;
            $scope.subdomain_available = false;
        } else {
            const params = {
                id: $('#org_id').text(),
                subdomain: subdomain
            };
            SubdomainAvailability.get(params, data => {
                if (data.status === 'ok') {
                    $scope.subdomain_checked = true;
                    $scope.subdomain_available = data.available;
                } else {
                    $scope.errors = [data.error];
                }
            });
        }
    });
}];

export const HelpTextsCtrl = ['$scope', 'HelpTexts', ($scope, HelpTexts) => {
    $scope.loaded = {
        helpTexts: false
    };
    HelpTexts.get({}, data => {
        if (data.status === 'ok') {
            $scope.loaded.helpTexts = true;
            $scope.helpTexts = data.helpTexts;
        } else {
            $scope.errors = [data.error];
        }
    });
    $scope.search = {
        helpTexts: ""
    };
}];

export const TagCreateCtrl = ['$scope', ($scope) => {
    $scope.tag = {
        title: '',
        shapeColor: '',
        textColor: '000000',
    };
}];

export const TagUpdateCtrl = ['$scope', ($scope) => {
    $scope.tag = {
        title: '',
        shapeColor: '',
        textColor: '',
    };
}];

export const ChecklistCtrl = ['$scope', ($scope) => {}];

export const ChecklistCreateCtrl = ['$scope', 'Tags', ($scope, Tags) => {
    $scope.tags = [];
    $scope.selectedTags = [];
    $scope.loaded = {
        tags: false
    };
    Tags.get({}, data => {
        if (data.status === 'ok') {
            $scope.tags = data.tags;
            $scope.loaded.tags = true;
        } else {
            $scope.errors = [data.error];
        }
    });

    $scope.image = '';
    $scope.croppedImage = '';
    $scope.useCroppedImage = () => {
        $("input[name='image_data']").val($scope.croppedImage);
        $scope.image = "";
    };
    $("#imageFileInput").on("change", evt => {
        let file = evt.currentTarget.files[0];
        let reader = new FileReader();
        reader.onload = evt => {
            $scope.$apply($scope => {
                $scope.image = evt.target.result;
            });
        };
        reader.readAsDataURL(file);
    });
}];

export const ChecklistUpdateCtrl = ['$scope', '$timeout', 'Socket', 'Upload', 'Checklist', 'SignatureRemoving', 'Tags', 'Image', ($scope, $timeout, Socket, Upload, Checklist, SignatureRemoving, Tags, Image) => {
    const isFinished = (item) => {
        if (item.isSeparator) {
            return true;
        }
        if (item.value === 0) {
            return false;
        }
        if (item.commentRequired && item.comment.length === 0 && item.value === 1) {
            return false;
        }
        return true;
    };
    const updateSigningStatus = (data) => {
        $scope.signingStatus = [];
        angular.forEach(data.signing_status, (rolesArray, status) => {
            rolesArray.forEach(role => {
                role.signingStatus = status;
                $scope.signingStatus.push(role);
            });
        });
        $scope.signingProgress = [];
        angular.forEach(data.signing_progress, (v, k) => {
            $scope.signingProgress[k] = v * 100;
        });
        // performance optimisation
        angular.forEach($scope.checklist.items, (item) => {
            item.isFinished = isFinished(item);
        });
    };
    $scope.stickyBar = {
        hiddenHeaders: true
    };
    $scope.loaded = {
        checklist: false,
        tags: false,
    };
    $scope.useAsRoleEnabled = true;
    $scope.tags = [];
    $scope.selectedTags = [];
    Tags.get({}, data => {
        if (data.status === 'ok') {
            $scope.tags = data.tags;
            $scope.loaded.tags = true;
        } else {
            $scope.errors = [data.error];
        }
    });
    $scope.openTagsSelector = () => {
        $scope.tagsForm = true;
        $scope.selectedTags = [];
        $scope.checklist.tags.forEach(obj => {
            $scope.selectedTags.push(obj._id);
        });
    };
    $scope.updateTags = () => {
        $scope.checklist.tags = [];
        $scope.selectedTags.forEach(selectedTag => {
            const t = $scope.tags.filter(tag => {
                return tag._id === selectedTag;
            })[0];
            $scope.checklist.tags.push(t);
        });
        $scope.selectedTags = [];
        $scope.updateChecklist();
    };
    $scope.$watch('useAsRole', () => {
        $scope.useAsRoleEnabled = true;
    });
    $scope.displayAllItems = () => {
        $scope.useAsRoleEnabled = false;
    };
    $scope.isItemSigned = item => {
        const role = $scope.signingStatus.filter(obj => {
            return item.signeeRole && obj._id === item.signeeRole._id;
        })[0];
        return role && role.signingStatus === $scope.$parent.signingStatusMap.signed;
    };
    $scope.highlighted = [];
    $scope.highlightSignBlockers = role => {
        $scope.highlighted.push(role);
    };
    const checklistId = window.location.pathname.split("/").clean('').pop();
    const isPreview = (window.location.pathname.indexOf('/checklist-preview/') > -1);
    $scope.loadChecklist = () => {
        Checklist.get({id:checklistId, preview:isPreview?1:0}, data => {
            if (data.status === 'ok') {
                $scope.checklist = data.checklist;
                $scope.$parent.$watch('user', () => {
                    $scope.useAsRole = $scope.checklist.definition.roles.filter(obj => {
                        return $scope.userHasRole(obj);
                    })[0];
                });
                updateSigningStatus(data);
                if (data.checklist.updated && data.checklist.updatedBy) {
                    $scope.syncStatus = "Last edit was on " + data.checklist.updated + " by " + data.checklist.updatedBy.first_name + " " + data.checklist.updatedBy.last_name;
                }
                $scope.loaded.checklist = true;
                Socket.emit('checklist_join', {
                    id: $scope.checklist._id
                });
                Socket.on('checklist_update', (data) => {
                    if (data.status === 'ok') {
                        $scope.checklist.status = data.checklist.status;
                        $scope.checklist.collaborators = data.checklist.collaborators;
                        $scope.checklist.attachments = data.checklist.attachments;
                        $scope.checklist.headers = data.checklist.headers;
                        $scope.checklist.items = data.checklist.items;
                        $scope.checklist.tags = data.checklist.tags;
                        $scope.checklist.revision = data.checklist.revision;
                        updateSigningStatus(data);
                        $scope.highlighted = [];
                        $scope.syncStatus = "Last edit was on " + data.checklist.updated + " by " + data.checklist.updatedBy.first_name + " " + data.checklist.updatedBy.last_name;
                        $scope.$applyAsync();
                    } else {
                        console.log(data.error);
                    }
                });
                Socket.on('checklist_update_success', (data) => {
                    $scope.syncStatus = "All changes saved to Chklsty";
                    $scope.checklist.revision = data.checklist.revision;
                    updateSigningStatus(data);
                    $scope.highlighted = [];
                    emitInProgress = false;
                    if (emitPending) {
                        emitChecklistUpdate();
                        emitPending = false;
                    }
                });
                Socket.on('checklist_update_error', (data) => {
                    $scope.syncStatus = data.message;
                    emitInProgress = false;
                    if (emitPending) {
                        emitChecklistUpdate();
                        emitPending = false;
                    }
                });
            } else {
                $scope.errors = [data.error];
            }
        });
    };
    let emitPending = false;
    let emitInProgress = false;
    const emitChecklistUpdate = (params) => {
        $timeout(() => {
            emitInProgress = true;
            Socket.emit('checklist_update', {
                checklist: $scope.checklist
            });
            if (params && params.reload) {
                $timeout(() => {
                    window.location.reload(true);
                }, 900);
            }
        });
    };
    $scope.updateChecklist = (params) => {
        if (isPreview) {
            $scope.syncStatus = "Cannot update Checklist in Preview mode";
        } else {
            if (emitInProgress) {
                emitPending = true;
            } else {
                emitChecklistUpdate(params);
            }
        }
    };

    const resetUploadProgress = () => {
        $scope.uploadInProgress = false;
        $scope.uploadInProgressFilename = "";
        $scope.uploadInProgressPct = 0;
    };
    resetUploadProgress();
    $scope.uploadFiles = (file, errFiles) => {
        const URL = baseURL + '/api/attachments/create/';
        $scope.errFile = errFiles && errFiles[0];
        if (file) {
            $scope.uploadInProgress = true;
            $scope.uploadInProgressFilename = file.name;
            file.upload = Upload.upload({
                url: URL,
                data: {
                    file: file
                }
            });
            file.upload.then(response => {
                $timeout(() => {
                    resetUploadProgress();
                    const data = response.data;
                    if (data.status === 'ok') {
                        $scope.checklist.attachments.push(data.attachment);
                        $scope.updateChecklist();
                        $scope.$apply();
                        $timeout(() => {
                            $('img').each((k, v) => {
                                if (_.startsWith(v.src, "http")) {
                                    if (v.src.indexOf('?') === -1) {
                                        $(v).attr('src', v.src + "?" + new Date().getTime());
                                    } else {
                                        $(v).attr('src', v.src.substring(0, v.src.indexOf('?')) + "?" + new Date().getTime());
                                    }
                                }
                            });
                        }, 300);
                    } else {
                        $scope.errors = [data.error];
                    }
                });
            }, response => {
                if (response.status > 0) {
                    $scope.errors = [response.status];
                }
                resetUploadProgress();
            }, evt => {
                $scope.uploadInProgressPct = parseInt(100.0 * evt.loaded / evt.total);
            });
        }
    };
    $scope.deleteAttachment = (attachment) => {
        $scope.checklist.attachments = $scope.checklist.attachments.filter(a => {
            return a._id !== attachment._id;
        });
        $scope.updateChecklist();
    };
    $scope.removeSignature = (role) => {
        SignatureRemoving.get({id: checklistId, role: role}, data => {
            if (data.status === 'ok') {
                window.location.reload(true);
            } else {
                $scope.errors = [data.error];
            }
        });
    };

    $scope.image = '';
    $scope.croppedImage = '';
    $scope.imageUpdate = false;
    $("#imageFileInput").on("change", evt => {
        let file = evt.currentTarget.files[0];
        let reader = new FileReader();
        reader.onload = evt => {
            $scope.$apply($scope => {
                $scope.image = evt.target.result;
            });
        };
        reader.readAsDataURL(file);
    });
    $scope.useCroppedImage = () => {
        $("input[name='image_data']").val($scope.croppedImage);
        $scope.image = "";
        const payload = {
            image: $scope.croppedImage
        };
        Image.save({}, payload, data => {
            if (data.status === 'ok') {
                $scope.checklist.image = data.image._id;
                $scope.updateChecklist({
                    reload: true
                });
            } else {
                $scope.errors = [data.error];
            }
        });
        $scope.imageUpdate = false;
    };
    $scope.removeCurrentImage = () => {
        $scope.checklist.image = "";
        $scope.imageUpdate = false;
        $scope.updateChecklist({
            reload: true
        });
    };
    $scope.cancelImageUpdate = () => {
        $scope.image = '';
        $scope.croppedImage = '';
        $scope.imageUpdate = false;
    };

    $scope.loadChecklist();
}];

export const ChecklistViewCtrl = ['$scope', '$timeout', '$window', 'Socket', 'Checklist', ($scope, $timeout, $window, Socket, Checklist) => {
    $scope.loaded = {
        checklist: false
    };
    const path = window.location.pathname.split("/").clean('');
    path.pop();
    const checklistId = path.pop();
    $scope.loadChecklist = () => {
        Checklist.get({id:checklistId}, data => {
            if (data.status === 'ok') {
                $scope.checklist = data.checklist;
                $scope.loaded.checklist = true;
            } else {
                $scope.errors = [data.error];
            }
        });
    };
    $scope.loadChecklist();
    $scope.submitChecklist = () => {
        Socket.emit('checklist_submit', {
            checklist: {
                _id: checklistId
            }
        });
        $window.location.href = '/';
    };
}];

export const ChecklistSigningCtrl = ['$scope', '$window', 'Socket', 'Checklist', 'Signing', ($scope, $window, Socket, Checklist, Signing) => {
    $scope.loaded = {
        checklist: false,
        signingStarted: false,
        signingEnded: false
    };
    const path = window.location.pathname.split("/").clean('');
    path.pop();
    const checklistId = path.pop();
    const roleId = window.location.getQueryParameter('role');
    $scope.loadChecklist = () => {
        Checklist.get({id:checklistId}, data => {
            if (data.status === 'ok') {
                $scope.checklist = data.checklist;
                $scope.loaded.checklist = true;
            } else {
                $scope.errors = [data.error];
            }
        });
    };
    $scope.loadChecklist();
    $scope.signChecklist = () => {
        $scope.loaded.signingStarted = true;
        Signing.save({id:checklistId, role:roleId}, {}, data => {
            if (data.status === 'ok') {
                $scope.errors = [];
                $scope.checklist = data.checklist;
                $scope.loaded.signingEnded = true;
                $scope.$applyAsync();
            } else {
                $scope.errors = [data.error];
            }
        }, error => {
            $scope.errors = ["An error occured. Please reload the page."];
        });
    };
    $scope.submitChecklist = (pdfURL) => {
        Socket.emit('checklist_submit', {
            checklist: {
                _id: checklistId
            }
        });
        if (pdfURL) {
            window.open(pdfURL);
        }
        $window.location.href = '/';
    };
}];

export const UserFormCtrl = ['$scope', 'Definitions', 'User', ($scope, Definitions, User) => {
    const userId = window.location.pathname.split("/").clean('').pop();
    $scope.timezone = 'Europe/Amsterdam';
    $scope.level = 'user';
    if (userId !== 'create') {
        User.get({id:userId}, data => {
            if (data.status === 'ok') {
                $scope.timezone = data.user.timezone;
                $scope.level = data.user.level;
            } else {
                $scope.errors = [data.error];
            }
        });
    }
    // see rolesSelection directive
    $scope.roles = [];
    Definitions.get({all: true}, data => {
        if (data.status === 'ok') {
            $scope.definitions = data.definitions;
        } else {
            $scope.errors = [data.error];
        }
    });
}];

export const UserSettingsFormCtrl = ['$scope', 'User', 'Definitions', 'Notifications', ($scope, User, Definitions, Notifications) => {
    $scope.timezone = '';
    User.get(data => {
        if (data.status === 'ok') {
            $scope.timezone = data.user.timezone;
        } else {
            $scope.errors = [data.error];
        }
    });
    Definitions.get({all: true}, data => {
        if (data.status === 'ok') {
            $scope.definitions = data.definitions;
        } else {
            $scope.errors = [data.error];
        }
    });
    const setNotifications = notifications => {
        const payload = {
            notifications: notifications
        };
        Notifications.save({}, payload, data => {
            if (data.status === 'ok') {
                //
            } else {
                $scope.errors = [data.error];
            }
        });
    };
    $scope.$parent.$watch('user.notifications', (newVal, oldVal) => {
        if (_.isEqual(newVal, oldVal) === false && typeof oldVal !== "undefined") {
            setNotifications(newVal);
        }
    }, true);
}];

export const RegistrationFormCtrl = ['$scope', 'SubdomainAvailability', ($scope, SubdomainAvailability) => {
    $scope.password = '';
    $scope.passwordStrength = null;
    $scope.subdomain = '';
    $scope.subdomain_checked = false;
    $scope.subdomain_available = false;
    $scope.$watch('subdomain', subdomain => {
        if (subdomain && subdomain.length === 0) {
            $scope.subdomain_checked = false;
        }
    });
    $scope.checkSubdomainAvailability = subdomain => {
        if (subdomain.length) {
            const params = {
                id: null,
                subdomain: subdomain
            };
            SubdomainAvailability.get(params, data => {
                if (data.status === 'ok') {
                    $scope.subdomain_checked = true;
                    $scope.subdomain_available = data.available;
                } else {
                    $scope.errors = [data.error];
                }
            });
        }
    };
}];

export const UserClaimFormCtrl = ['$scope', ($scope) => {
    $scope.password = '';
    $scope.passwordRepeat = '';
    $scope.passwordLength = 12;

    $scope.generatePassword = () => {
        const lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
        const upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        const numbers = ['0','1','2','3','4','5','6','7','8','9'];
        let finalCharacters = lowerCharacters;
        finalCharacters = finalCharacters.concat(upperCharacters);
        finalCharacters = finalCharacters.concat(numbers);
        const passwordArray = [];
        for (let i = 1; i < $scope.passwordLength; i++) {
            passwordArray.push(finalCharacters[Math.floor(Math.random() * finalCharacters.length)]);
        }
        $scope.password = passwordArray.join("");
        $scope.passwordRepeat = $scope.password;
    };

    $scope.passwordCopied = () => {
        alert("Password copied to clipboard")
    };
    $scope.passwordNotCopied = error => {
        alert("Password cannot be copied to clipboard. Use a modern browser, please.")
    };
}];

export const StripeAddCardCtrl = ['$scope', 'config', 'StripeConfiguration', 'StripeSetupIntent', 'StripeSubscription', ($scope, config, StripeConfiguration, StripeSetupIntent, StripeSubscription) => {
    $scope.paymentFormToggle = false;
    $scope.savingPaymentMethod = false;

    const initStripe = publicKey => {
        const stripe = Stripe(publicKey);
        const elements = stripe.elements();
        const cardElement = elements.create('card', {style: config.stripe.style});
        if ($('#card-element')) {
            cardElement.mount('#card-element');
            cardElement.on('change', event => {
                const displayError = $('#card-errors');
                if (event.error) {
                    displayError.text(event.error.message);
                } else {
                    displayError.text('');
                }
            });

            const form = $('#stripe-cc-form');
            form.on('submit', event => {
                event.preventDefault();
                $scope.savingPaymentMethod = true;
                $scope.$apply();

                StripeSetupIntent.get({}, data => {
                    if (data.status === 'ok') {
                        const clientSecret = data.stripe.intent_client_secret;
                        stripe.confirmCardSetup(clientSecret, {
                            payment_method: {
                                card: cardElement,
                                billing_details: {
                                    name: $('#cardholder-name').val(),
                                    email: $('#cardholder-email').val(),
                                },
                            },
                        }).then(result => {
                            if (result.error) {
                                $('#card-errors').text(result.error.message);
                                $scope.savingPaymentMethod = false;
                                $scope.$apply();
                            } else {
                                const paymentMethodId = result.setupIntent.payment_method;
                                StripeSubscription.save({}, { paymentMethod: paymentMethodId }, saveData => {
                                    if (saveData.status === 'ok') {
                                        window.location.reload(true);
                                    } else {
                                        $('#card-errors').text(saveData.error);
                                        $scope.savingPaymentMethod = false;
                                        $scope.$apply();
                                    }
                                });
                            }
                        });
                    } else {
                        $('#card-errors').text(data.error);
                        $scope.savingPaymentMethod = false;
                        $scope.$apply();
                    }
                });
            });
        }
    };

    StripeConfiguration.get({}, data => {
        if (data.status === 'ok') {
            initStripe(data.stripe['publicKey']);
        } else {
            $scope.errors = [data.errors];
        }
    });
}];

export const StripeUpdateCardCtrl = ['$scope', 'config', 'StripeConfiguration', 'StripeSetupIntent', 'StripeCardUpdate', 'StripeCardRemove', ($scope, config, StripeConfiguration, StripeSetupIntent, StripeCardUpdate, StripeCardRemove) => {
    $scope.paymentFormToggle = false;
    $scope.updatingPaymentMethod = false;

    const initStripe = publicKey => {
        const stripe = Stripe(publicKey);
        const elements = stripe.elements();
        const cardElement = elements.create('card', {style: config.stripe.style});
        if ($('#card-element')) {
            StripeSetupIntent.get({}, data => {
                if (data.status === 'ok') {
                    const form = $('#stripe-cc-form');
                    const intentClientSecret = data.stripe.intent_client_secret;
                    form.data('secret', intentClientSecret);
                    cardElement.mount('#card-element');
                    cardElement.on('change', event => {
                        const displayError = $('#card-errors');
                        if (event.error) {
                            displayError.textContent = event.error.message;
                        } else {
                            displayError.textContent = '';
                        }
                    });
                    const cardholderName = $('#cardholder-name');
                    $('#stripe-cc-form button').on('click', event => {
                        event.preventDefault();
                        stripe.confirmCardSetup(
                            intentClientSecret,
                            {
                                payment_method: {
                                    card: cardElement,
                                    billing_details: {
                                        name: cardholderName.name
                                    }
                                }
                            }
                        ).then(result => {
                            if (result.error) {
                                const errorElement = $('#card-errors');
                                errorElement.textContent = result.error.message;
                                $scope.updatingPaymentMethod = false;
                                $scope.$apply();
                            } else {
                                StripeCardUpdate.get({}, data => {
                                    if (data.status === 'ok') {
                                        window.location.reload(true);
                                    } else {
                                        $scope.errors = [data.error];
                                    }
                                    $scope.updatingPaymentMethod = false;
                                });
                            }
                        });
                    });
                }
            });
        }
    };

    StripeConfiguration.get({}, data => {
        if (data.status === 'ok') {
            initStripe(data.stripe['publicKey']);
        } else {
            $scope.errors = [data.errors];
        }
    });

    $scope.removePaymentMethod = () => {
        StripeCardRemove.get({}, data => {
            if (data.status === 'ok') {
                window.location.reload(true);
            } else {
                $scope.errors = [data.error];
            }
        });
    };
}];
